export default __webpack_public_path__ + "static/media/vehicles.a3963710.svg";